import { SlideType } from '@/utils/types/enums';

import { CaseConfig } from '../types';
import {
  doesMasterClassQuestionHaveACorrectAnswer,
  isMasterClassAnswerCorrect,
} from './answer-validator';

/**
 * Calcule le score à partir des réponses et de la config du case
 * @param answeredQuestions - Map des réponses : {"question-id": "answer-id" | ["answer-id1", "answer-id2"]}
 * @param caseConfig - Configuration complète du case
 * @returns Nombre de réponses correctes, total de questions et pourcentage
 */
export function calculateScore(
  answeredQuestions: Record<string, string | string[]>,
  caseConfig: CaseConfig
): {
  correctAnswers: number;
  totalQuestions: number;
  scorePercentage: number;
} {
  const questionSlides = caseConfig.slides.filter((slide) =>
    [
      SlideType.QUESTION_SINGLE,
      SlideType.QUESTION_MULTIPLE,
      SlideType.QUESTION_MULTIPLE_ORDERED,
    ].includes(slide.type)
  );

  let correctAnswers = 0;

  questionSlides.forEach((slide) => {
    const userAnswer = answeredQuestions[slide.id];
    const masterClassQuestionHasObtainableCorrectAnswer = doesMasterClassQuestionHaveACorrectAnswer(
      caseConfig,
      slide.id
    );

    if (!userAnswer) return;

    // Handle multiple choice answers
    if (Array.isArray(userAnswer)) {
      const isCorrect = isMasterClassAnswerCorrect(caseConfig, slide.id, userAnswer);
      if (isCorrect || !masterClassQuestionHasObtainableCorrectAnswer) {
        correctAnswers++;
      }
      // Single choice answer
    } else {
      const isCorrect = isMasterClassAnswerCorrect(caseConfig, slide.id, [userAnswer]);
      if (isCorrect || !masterClassQuestionHasObtainableCorrectAnswer) {
        correctAnswers++;
      }
    }
  });

  const totalQuestions = questionSlides.length;
  const scorePercentage = totalQuestions > 0 ? (correctAnswers / totalQuestions) * 100 : 0;

  return { correctAnswers, totalQuestions, scorePercentage };
}
